import React from 'react';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useQuery} from '@apollo/client';
import {ErrorBlock, NavBar, Skeleton} from 'antd-mobile';
import {
    GET_DSP_PARTICULARS_DETAIL,
    GetDspPackageDetailByTrackingNumberResponse, GetDspPackageDetailByTrackingNumberVariables
} from "../graphql/queries/getPackageDetail";
import {getNavBarContainerStyle} from "../../../utils/deviceUtils";
import {DspPath} from "../../../enums/DeliveryNavigatePathEnum";
import {PackageBasicInfo} from '../../../components/PackageBasicInfo';

const DspParticularsDetailPage: React.FC = () => {
    const navigate = useNavigate();
    const {trackingNumber} = useParams<{ trackingNumber: string }>();
    const [searchParams] = useSearchParams();
    const {t, i18n} = useTranslation();

    // 查询DSP包裹详情
    const {
        data: packageData,
        loading,
        error
    } = useQuery<GetDspPackageDetailByTrackingNumberResponse, GetDspPackageDetailByTrackingNumberVariables>(
        GET_DSP_PARTICULARS_DETAIL,
        {
            variables: {
                trackingNumber: trackingNumber || ""
            },
            skip: !trackingNumber,
            fetchPolicy: 'cache-and-network'
        }
    );

    const packageDetail = packageData?.getDspPackageDetailByTrackingNumber;


    if (loading) {
        return (
            <div className="flex flex-col h-screen bg-white">
                <div {...getNavBarContainerStyle()}>
                    <NavBar onBack={() => navigate(-1)}>{trackingNumber}</NavBar>
                </div>
                <Skeleton.Title animated/>
                <Skeleton.Paragraph lineCount={5} animated/>
                <Skeleton.Title animated/>
                <Skeleton.Paragraph lineCount={3} animated/>
            </div>
        );
    }

    if (error || !packageDetail) {
        return (
            <div className="p-4">
                <ErrorBlock
                    status="empty"
                    title={t('pages.dsp.packageDetail.packageNotFound', '包裹不存在')}
                    description={t('pages.dsp.packageDetail.packageNotFoundDescription', '未找到该运单号对应的包裹信息')}
                />
            </div>
        );
    }

    const renderBasicInfoTab = () => (
        <div className="bg-gray-50 min-h-full">
            {/* 基础信息 */}
            <PackageBasicInfo
                packageDetail={packageDetail}
                currentLanguage={i18n.language}
            />
        </div>
    );

    return (
        <div className="flex flex-col h-screen">
            <div {...getNavBarContainerStyle()}>
                <NavBar
                    onBack={() => {
                        // 构建返回URL，包含所有必要参数
                        const driverId = searchParams.get('driverId');
                        const date = searchParams.get('date');
                        const tabType = searchParams.get('tabType');
                        const taskTabType = searchParams.get('taskTabType');
                        const taskId = searchParams.get('taskId');

                        // 检查是否从任务详情页面跳转过来
                        if (taskTabType) {
                            // 从任务详情页面跳转过来，返回到任务详情页面
                            navigate(DspPath.DELIVERY_DSP_DELIVERY_TASK_DETAILS, {
                                state: {
                                    taskId: taskId ? parseInt(taskId) : 0,
                                    activeTab: taskTabType
                                }
                            });
                        } else if (driverId) {
                            // 从运营数据页面跳转过来，返回到对应的tab
                            const returnParams = new URLSearchParams();
                            if (tabType) returnParams.set('tabType', tabType);
                            if (driverId) returnParams.set('driverId', driverId);
                            if (date) returnParams.set('date', date);
                            navigate(`${DspPath.DELIVERY_DSP_OPERATIONAL_PARTICULARS.replace(':driverId', driverId)}?${returnParams.toString()}`);
                        } else {
                            navigate(-1);
                        }
                    }}
                >
                    {trackingNumber}
                </NavBar>
            </div>
            {/* Tab切换 */}
            <div className="flex-1 overflow-y-auto">
                {renderBasicInfoTab()}
            </div>
        </div>
    );
};


export default DspParticularsDetailPage;